import { createI18n } from 'vue-i18n'
const { mergeMessages } = require('./catalog/productCatalog.cjs')

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages() {
  const locales = require.context('./locales', false, /[A-Za-z0-9-_,\s]+\.yml$/i)
  const messages = {}
  console.log(locales)
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    console.log(matched)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      console.log(locales(key))
      messages[locale] = locales(key).default
    }
  })
  console.log(messages)
  return messages
}

export default createI18n({
  allowComposition: true,  // to use with Composition API
  legacy: false,    
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  globalInjection: true,
  messages: mergeMessages(loadLocaleMessages())
})
